function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "D3771BCE-CCFE-49B9-87E3-2358BA206C72");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-850.000000, -244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "50px_8",
  transform: "translate(630.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 50 0 50 50 0 50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47,21.5 L47,12.5 C47,10.0025 45.02,8 42.6,8 L7.4,8 C4.98,8 3.022,10.0025 3.022,12.5 L3.022,21.5 C5.442,21.5 7.4,23.525 7.4,26 C7.4,28.475 5.442,30.5 3,30.5 L3,39.5 C3,41.975 4.98,44 7.4,44 L42.6,44 C45.02,44 47,41.975 47,39.5 L47,30.5 C44.58,30.5 42.6,28.475 42.6,26 C42.6,23.525 44.58,21.5 47,21.5 Z M42.6,18.215 C39.982,19.7675 38.2,22.6925 38.2,26 C38.2,29.3075 39.982,32.2325 42.6,33.785 L42.6,39.5 L7.4,39.5 L7.4,33.785 C10.018,32.2325 11.8,29.3075 11.8,26 C11.8,22.67 10.04,19.7675 7.422,18.215 L7.4,12.5 L42.6,12.5 L42.6,18.215 Z M22.8,32.75 L27.2,32.75 L27.2,37.25 L22.8,37.25 L22.8,32.75 Z M22.8,23.75 L27.2,23.75 L27.2,28.25 L22.8,28.25 L22.8,23.75 Z M22.8,14.75 L27.2,14.75 L27.2,19.25 L22.8,19.25 L22.8,14.75 Z",
  id: "Shape",
  fill: "currentColor",
  fillRule: "nonzero"
})))))));

var SvgIconTicketsKronos = function SvgIconTicketsKronos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTicketsKronos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconTicketsKronos.5512e585.svg";
export { ForwardRef as ReactComponent };